/* eslint-disable no-unused-vars */
export const LOGOUT = 'LOGOUT'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const SET_MANAGE_PROFILE = 'SET_MANAGE_PROFILE'
export const CLEAR_MANAGE_GOALS = 'CLEAR_MANAGE_GOALS'
export const SET_MANAGE_GOALS = 'SET_MANAGE_GOALS'
/* eslint-enable no-unused-vars */



// WEBPACK FOOTER //
// ./src/store/mutation-types.js